import { apiBasePath, PAGINATION_AND_SORTING } from "../constants/constants";
import ApiService from "../utils/api-service";
import { addMaxParam, addOffsetParam, addQueryParam, addSortByParam, addSortOrderParam } from "../utils/utils";

export function getBootcampByIdOnAssessmentApi({ bootcampId }) {
  let apiUrl = `${apiBasePath}/bootcamps/${bootcampId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getModuleByIdOnAssessmentApi(data) {
  let apiUrl = `${apiBasePath}/modules/${data.moduleId}`;

  if (
    data?.bootcampId !== undefined &&
    data?.bootcampId !== null &&
    data?.bootcampId !== ""
  ) {
    apiUrl += `?bootcampId=${data?.bootcampId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}

export function getAssessmentApi(data) {
  let apiUrl = `${apiBasePath}/assessment`;

  if (
    data?.bootcampId !== undefined &&
    data?.bootcampId !== null &&
    data?.bootcampId !== ""
  ) {
    apiUrl += `?bootcampId=${data?.bootcampId}`;
  }

  if (
    data?.moduleId !== undefined &&
    data?.moduleId !== null &&
    data?.moduleId !== ""
  ) {
    apiUrl += `?moduleId=${data?.moduleId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function getAssessmentByIdApi(id) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/assessment/${id}`,
    data: id,
  };
  return ApiService(options);
}

export function addAssessmentApi(data) {
  const options = {
    method: "POST",
    url: `${apiBasePath}/assessment`,
    data: data,
  };
  return ApiService(options);
}

export function editAssessmentApi(data) {
  const options = {
    method: "PATCH",
    url: `${apiBasePath}/assessment`,
    data: data,
  };
  return ApiService(options);
}

export function fetchModulesListApi(id) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/utilities/optionsForCreateEditAssessment?bootcampId=${id}`,
    data: id,
  };
  return ApiService(options);
}

export function fetchSessionsListApi(id) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/utilities/optionsForCreateEditAssessment?moduleId=${id}`,
    data: id,
  };
  return ApiService(options);
}

function addAssessment(data, apiUrl) {
  if (
    data?.assessmentId !== undefined &&
    data?.assessmentId !== null &&
    data?.assessmentId !== ""
  ) {
    apiUrl += `?assessmentId=${data?.assessmentId}`;
  }
  return apiUrl;
}

function addTitle(data, apiUrl) {
  if (data?.title !== undefined && data?.title !== null && data?.title !== "") {
    apiUrl += `&title=${data?.title}`;
  }
  return apiUrl;
}

function addType(data, apiUrl) {
  if (
    data?.type?.length &&
    data?.type !== undefined &&
    data?.type !== null &&
    data?.type !== ""
  ) {
    apiUrl += `&type=${data?.type}`;
  }
  return apiUrl;
}

function addDifficultyLevel(data, apiUrl) {
  if (
    data?.difficultyLevel?.length &&
    data?.difficultyLevel !== undefined &&
    data?.difficultyLevel !== null &&
    data?.difficultyLevel !== ""
  ) {
    apiUrl += `&difficultyLevel=${data?.difficultyLevel}`;
  }
  return apiUrl;
}

function addShowActive(data, apiUrl) {
  if (data?.showActive !== undefined && data?.showActive !== "") {
    apiUrl += `&showActive=${data?.showActive}`;
  }
  return apiUrl;
}

function addOffset(data, apiUrl) {
  if (data?.offset !== undefined && data?.offset !== "") {
    apiUrl += `&offset=${data?.offset * 20}`;
  }
  return apiUrl;
}

function addSortBy(data, apiUrl) {
  if (data?.sortBy !== undefined && data?.sortBy !== null) {
    apiUrl += `&sortBy=${data?.sortBy}`;
  }
  return apiUrl;
}

function addSortOrder(data, apiUrl) {
  if (data?.sortOrder !== undefined && data?.sortOrder !== null) {
    apiUrl += `&sortOrder=${data?.sortOrder}`;
  }
  return apiUrl;
}

export function fetchAssessmentQuestionsApi(data) {
  let apiUrl = `${apiBasePath}/assessmentQuestion`;
  apiUrl = addAssessment(data, apiUrl);
  apiUrl = addTitle(data, apiUrl);
  apiUrl = addType(data, apiUrl);
  apiUrl = addDifficultyLevel(data, apiUrl);
  apiUrl = addShowActive(data, apiUrl);
  apiUrl = addOffset(data, apiUrl);
  apiUrl = addSortBy(data, apiUrl);
  apiUrl = addSortOrder(data, apiUrl);
  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}
